// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"259":"component---src-pages-editor-js","269":"component---src-templates-storyblok-entry-js","351":"commons","532":"styles"}[chunkId] + "-" + {"259":"583d4b8daac010817781","269":"2c4eff4a58953f00aa5b","351":"9b2e6bb9271d1ce0e048","532":"c1b30e72dd1c97ef80cb"}[chunkId] + ".js";
};